import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LateFee } from './LateFee';
import { AdminFee } from './AdminFee';
import { AccountSetupFee } from './AccountSetupFee';
import { useStore } from 'src/stores';
import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { FEE_PROPERTY_TYPES } from 'src/constants/feesSetting';
import { useAccountSetupFeePrice } from 'src/utils/hooks/useAccountSetupFeePrice';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader, toast } from '@livable/saas-react-components';
export const FeeSetupModalContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS8;
  let handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const accountSetupFeePrice = useAccountSetupFeePrice({
    propertyId: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id,
    isEnabled: store.account.featureFlagsStore.getIsAccountSetupFeeEnabled
  });
  const submitForm = async () => {
    var _store$homeDashboardS2, _store$homeDashboardS3;
    const resp = await store.properties.updatePropertyFeesV2Async.run(_objectSpread({
      propertyId: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id
    }, (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.selectedPropertyDetails().details.feeSetup.getPropertyFees({
      feeNames: Object.keys(FEE_PROPERTY_TYPES),
      isAccountSetupFeeEnabled: accountSetupFeePrice !== null
    })));
    if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) {
      var _store$homeDashboardS4, _store$homeDashboardS5;
      await store.properties.getPropertyFeesV2Async.run({
        applyToStore: true,
        applyToHomeDashboard: true,
        propertyId: (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.id
      });
      toast('success', {
        body: ['Successfully saved']
      });
      (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || _store$homeDashboardS5.selectedPropertyDetails().details.feeSetup.initAfterLoadState();
      handleClose();
    }
  };
  useEffect(() => {
    var _store$homeDashboardS6;
    (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || _store$homeDashboardS6.selectedPropertyDetails().details.feeSetup.initAfterLoadState();
    return () => {
      var _store$homeDashboardS7;
      (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 || _store$homeDashboardS7.selectedPropertyDetails().details.feeSetup.applyAfterLoadState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AdminFee, null), /*#__PURE__*/React.createElement(AccountSetupFee, {
    price: accountSetupFeePrice
  }), !store.company.companyFeatureStore.disableLateFee && !store.company.companyFeatureStore.convergentBillingMode && /*#__PURE__*/React.createElement(LateFee, null), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => handleClose(),
    'custom-attribute': '664-new-billing-module'
  }, t('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.payment.getStripeProductsAsync.inProgress || store.properties.getPropertyFeesV2Async.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || !((_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS8 !== void 0 && _store$homeDashboardS8.selectedPropertyDetails().details.feeSetup.feesValidation),
    onClick: submitForm,
    type: "button",
    variant: "contained",
    'custom-attribute': '665-new-billing-module'
  }, t('Save fees')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getStripeProductsAsync.inProgress || store.properties.getPropertyFeesV2Async.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress
  }));
});